// ANETT HORVATH — Preview Bar
// Admin-only: simulate viewing as different membership levels.

import { useState } from 'react';
import { useStore } from '../store/database';
import type { MembershipAccess } from '../core/render-policy';

const LEVELS: { value: MembershipAccess | 'off'; label: string }[] = [
  { value: 'off', label: 'Admin View' },
  { value: 'public', label: 'Public' },
  { value: 'waitlist', label: 'Waitlist' },
  { value: 'member', label: 'Member' },
  { value: 'inner_circle', label: 'Inner Circle' },
];

interface PreviewBarProps {
  onPreviewChange: (level: MembershipAccess | null) => void;
  current: MembershipAccess | null;
}

export default function PreviewBar({ onPreviewChange, current }: PreviewBarProps) {
  const session = useStore(s => s.session);
  if (!session || session.role !== 'super_admin') return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] bg-charcoal text-ivory flex items-center justify-center gap-2 py-1.5 px-4 text-[10px] tracking-widest uppercase font-sans">
      <span className="text-gold mr-2">Preview As:</span>
      {LEVELS.map(l => (
        <button
          key={l.value}
          onClick={() => onPreviewChange(l.value === 'off' ? null : l.value as MembershipAccess)}
          className={`px-3 py-1 transition-colors ${
            (l.value === 'off' && !current) || l.value === current
              ? 'bg-gold text-charcoal' : 'text-ivory/50 hover:text-ivory'
          }`}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
}
